import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitToEllipsis'
})
export class LimitToEllipsisPipe implements PipeTransform {

  transform(value: string, args: number, name?: boolean): string {
    let a = args ? args.toString() : '';
    let limit = args ? parseInt(a, 10) : 10;
    let ellipsis = '...';
    if (name === false)
      ellipsis = '';
    if (value)
      return value.length > limit ? value.substring(0, limit) + ellipsis : value;
    else
      return value;
  }

}
